/**
 * @file SpacerWidget.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-03-17
 *
 * Empty spacer widget for layout control
 */

function SpacerWidget() {
  return (
    <div className="dashboard-card spacer-card">
      <div className="card-body" />
    </div>
  );
}

export default SpacerWidget;
